import { Route, Routes, Navigate, useLocation } from 'react-router'
import { TextEnableLandlineRoutes } from 'pages/settings/pages/numbers/pages/TextEnableLandline/route/type'
import { TextEnableLandlineAccessLayout } from 'pages/settings/pages/numbers/pages/TextEnableLandline/layout/textEnableLandlineAccessLayout'
import { TextEnableLandlineProviderLayout } from 'pages/settings/pages/numbers/pages/TextEnableLandline/layout/textEnableLandlineProviderLayout'
import { TextEnableLandlineStepsLayout } from 'pages/settings/pages/numbers/pages/TextEnableLandline/layout/textEnableLandlineStepsLayout'
import { EnterNumber } from 'pages/settings/pages/numbers/pages/TextEnableLandline/ui/EnterNumber'
import { EnterAddress } from 'pages/settings/pages/numbers/pages/TextEnableLandline/ui/EnterAddress'
import { VerifyNumber } from 'pages/settings/pages/numbers/pages/TextEnableLandline/ui/VerifyNumber'
import { AssignNumber } from 'pages/settings/pages/numbers/pages/TextEnableLandline/ui/AssignNumber'
import { AuthorizationDocument } from 'pages/settings/pages/numbers/pages/TextEnableLandline/ui/AuthorizationDocument'

export const TextEnableLandlineStepsRouter = () => {
  const { search } = useLocation()

  return (
    <Routes>
      <Route element={<TextEnableLandlineAccessLayout />}>
        <Route
          path={'/'}
          element={<Navigate to={`${TextEnableLandlineRoutes.steps}${search}`} replace />}
        />

        <Route element={<TextEnableLandlineProviderLayout />}>
          <Route
            path={`${TextEnableLandlineRoutes.steps}/*`}
            element={<TextEnableLandlineStepsLayout />}
          >
            <Route path={TextEnableLandlineRoutes.enterNumber} element={<EnterNumber />} />
            <Route path={TextEnableLandlineRoutes.enterAddress} element={<EnterAddress />} />
            <Route path={TextEnableLandlineRoutes.verifyNumber} element={<VerifyNumber />} />
            <Route
              path={TextEnableLandlineRoutes.authorizationDocument}
              element={<AuthorizationDocument />}
            />
            <Route path={TextEnableLandlineRoutes.assignNumber} element={<AssignNumber />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  )
}
